var $ = require('jquery');

$(document).ready(function () {
    var copyLinkButtonClicked = false;
    $('.copy-link-icon').on('click', function (event) {
        var copySuccessMessage = $(this).data('copy-url-success');
        if (!copyLinkButtonClicked) {
            copyLinkButtonClicked = true;
            var fadeOut = document.createElement("div");
            fadeOut.setAttribute("class", "fadeout-copy-confirmation");
            fadeOut.setAttribute("style", "position: absolute; user-select: none; background-color: #fff; padding: 2px 4px; font-size: 1.2rem; border: 1px solid black; z-index: 999; transition: 1.5s; left: " + event.pageX + "px; top: " + event.pageY + "px;");

            document.getElementsByTagName("body")[0].append(fadeOut);
            $('.fadeout-copy-confirmation').html(copySuccessMessage);
            window.setTimeout(function () {
                $('.fadeout-copy-confirmation').css('opacity', 0);
                window.setTimeout(function () {
                    document.getElementsByClassName('fadeout-copy-confirmation')[0].remove();
                    copyLinkButtonClicked = false;
                }, 1500);
            }, 500);
        }
        navigator.clipboard.writeText($(this).data('canonical-link'));
    });


    if (window.SitecoreUtilities.isPageEditor) {
        var bcVideo = $('.featured-hero-jumplink__video').find('.brightcove-video');
        if (bcVideo.length > 0 && bcVideo.data('has-transcript') == "False") {
            bcVideo.find('.p3sdk-interactive-transcript-content').html("No transcript available");
        }
    }


    //add logic to determine if we are using featured hero jumplinks or the social share jumplinks
    var jumplinkContainer;
    var jumplinkContainerClass;
    var jumplinkClass;
    var jumplinkWrapperClass; //if no wrapper, set this equal to the jumplinkClass
    var jumplinkMobileClass;
    var stickyNavDesktopClass;
    var stickyNavMobileClass;
    var headerOverrideClass;
    var mobileButtonClass;
    var usingAnchors = true;

    //Check for presence of featured hero jumplinks or 801 social links
    if ($('.featured-hero-jumplink.jumplinks').length > 0 || $('.801-social-sharing-wrapper.jumplinks').length > 0) {
        if ($('.featured-hero-jumplink.jumplinks').length > 0) {
            jumplinkContainer = $('.featured-hero-jumplink.jumplinks').first();
            jumplinkContainerClass = ".featured-hero-jumplink__menu__desktop";
            jumplinkClass = ".featured-hero-jumplink__menu__desktop--item";
            jumplinkWrapperClass = jumplinkClass;
            jumplinkMobileClass = ".featured-hero-jumplink__menu__mobile--item";
            stickyNavDesktopClass = ".featured-hero-jumplink__container__stickynav";
            stickyNavMobileClass = ".featured-hero-jumplink__menu__mobile__stickynav";
            headerOverrideClass = "featured-hero-jumplink-override";
            mobileButtonClass = "featured-hero-jumplink__menu__mobile--button";
        }
        else if ($('.801-social-sharing-wrapper.jumplinks').length > 0) {
            jumplinkContainer = $('.801-social-sharing-wrapper.jumplinks').first();
            jumplinkContainerClass = ".article-header__social-jumplinks";
            jumplinkClass = ".article-header__social-jumplink";
            jumplinkWrapperClass = ".article-header__social-jumplinks__link";
            jumplinkMobileClass = ".article-header__social-jumplinks__mobile-link";
            stickyNavDesktopClass = ".article-header__social-jumplinks__container__stickynav";
            stickyNavMobileClass = ".article-header__social-jumplinks__menu__mobile__stickynav";
            headerOverrideClass = "article-header__social-jumplinks-override";
            mobileButtonClass = "article-header__social-jumplinks__menu__mobile--button"
        }

        var stickyNavDesktopContainer = jumplinkContainer.find(stickyNavDesktopClass);
        var stickyNavMobileContainer = jumplinkContainer.find(stickyNavMobileClass);
        if (jumplinkContainer.find(jumplinkClass).length !== 0) {
            //quick check for existing window.location.hash
            if (window.location.hash.length > 0) {
                smoothScrollToAnchor(0, event);
            }
            // Setup isScrolling variable
            var isScrolling;
            var stillScrolling;
            var scrolling = false;
            var stickyNavTimeout;
            var lastScrollTop = 0;
            var windowResize;
            var jumplinksDistanceFromTop = $(jumplinkContainerClass).first().offset().top;
            var mobileJumplinksDistanceFromTop = $(jumplinkMobileClass).first().offset().top;
            var jumplinkTopDistance = [];
            var anchorElements = stickyNavDesktopContainer.find(jumplinkClass);
            var anchorElementWrappers = (jumplinkClass !== jumplinkWrapperClass) ? stickyNavDesktopContainer.find(jumplinkWrapperClass) : null;
            function anchorPointCalc() {
                jumplinkTopDistance = [];
                if (usingAnchors) {
                    $(anchorElements).each(function () {
                        var t = $(this);
                        if (t.attr('href')) {
                            if (t.attr('href').substring(0, 1) === "#") {
                                var targetedAnchor = t.attr('href');
                                var anchorOffsetTop = ($(window).width() <= 991) ? $(targetedAnchor).offset().top + mobileJumplinksDistanceFromTop : $(targetedAnchor).offset().top - 80 /*+ jumplinksDistanceFromTop*/;
                                jumplinkTopDistance.push(anchorOffsetTop - 30);
                            }
                            else {
                                usingAnchors = false;
                                return false;
                            }
                        }
                    });

                    jumplinkTopDistance.push(9999999);
                }
            }

            var anchorpointsCalc = window.setTimeout(function () {
                anchorPointCalc();
            }, 500);


            $('.tabbed-section-navigation__tabs__tab__name').on('click', function () {
                anchorpointsCalc = window.setTimeout(function () {
                    anchorPointCalc();
                }, 100);
            });

            $(document).on('beforeShow.fb', function (e, instance, slide) {
                stickyNavDesktopContainer.removeClass('scrollable_nav');
            });
            $(document).on('beforeClose.fb', function (e, instance, slide) {
                //only add this class if the nav should be active
                if (window.pageYOffset >
                    (mobileJumplinksDistanceFromTop +
                        jumplinkContainer.find('.' + mobileButtonClass + '.dropdown-toggle')[0].offsetHeight)) {
                    stickyNavDesktopContainer.addClass('scrollable_nav');
                }
            });

            // Listen for scroll events
            window.addEventListener('scroll', function (event) {
                scrolling = true;
                // Clear our timeout throughout the scroll
                window.clearTimeout(isScrolling);
                // Set a timeout to run after scrolling ends
                isScrolling = setTimeout(function () {
                    // Run the callback
                    scrolling = false;
                    window.clearTimeout(scrolling);
                }, 266);
                stillScrolling = setTimeout(function () {
                    if (scrolling) {
                        stickyNavStatus();
                    }
                }, 266);
            }, false);

            // Listen for window resize, then recalculate the anchor points
            $(window).resize(function () {
                window.clearTimeout(windowResize);
                windowResize = setTimeout(function () {
                    anchorPointCalc();
                }, 300);
            });

            function stickyNavStatus() {
                var st = window.pageYOffset || document.documentElement.scrollTop;
                if (st === lastScrollTop) {
                    checkScrollLocation();
                    return false;
                }

                if (window.pageYOffset > (jumplinkContainer.find(jumplinkContainerClass)).offset().top) {
                    stickyNavDesktopContainer.addClass('scrollable_nav');
                    $('header.header').addClass(headerOverrideClass);
                } else {
                    stickyNavTimeout = setTimeout(function () {
                        stickyNavDesktopContainer.removeClass('scrollable_nav');
                    }, 160);

                    $('header.header').removeClass(headerOverrideClass);
                }
                //adding for mobile stickynav
                if ($(window).width() <= 991) {
                    if (window.pageYOffset > (mobileJumplinksDistanceFromTop - 100)) {
                        stickyNavMobileContainer.addClass('scrollable_nav');
                        $('header.header').addClass(headerOverrideClass);

                    } else {
                        stickyNavMobileContainer.removeClass('scrollable_nav');
                        $('header.header').removeClass(headerOverrideClass);
                    }
                }


                if (st < lastScrollTop) {
                    stickyNavDesktopContainer.removeClass('scrollable_nav');
                    stickyNavMobileContainer.removeClass('scrollable_nav');
                    $('header.header').removeClass(headerOverrideClass);
                }
                lastScrollTop = st <= 0 ? 0 : st;

                checkScrollLocation();
            }

            // add smooth scrolling to jumplist menu desktop items
            jumplinkContainer.find(jumplinkClass).on('click', function (event) {
                smoothScrollToAnchor(this, event);
            });

            // add smooth scrolling to jumplist menu mobile modal items
            jumplinkContainer.find(jumplinkMobileClass).on('click', function (event) {
                smoothScrollToAnchor(this, event);

                var buttonText = $(this).html();

                if (buttonText !== '') {
                    // update button text to the current selection
                    $('.' + mobileButtonClass).html(buttonText + ' <i class="material-icons">expand_more</i>');
                }
            });

            stickyNavMobileContainer.on('click', function () {
                stickyNavMobileContainer.removeClass('scrollable_nav');
            });

            //close fancybox after mobile link click if usingAnchors is false
            $('.article-header__social-jumplinks__mobile-link').on('click', function () {
                if (!usingAnchors) {
                    if ($('.fancybox-container').hasClass('fancybox-is-open')) {
                        $.fancybox.close();
                    }
                }
            });

            function smoothScrollToAnchor(t, event) {
                if (usingAnchors) {
                    // prevent default click behavior and check for anchor class
                    if (t !== 0) {
                        if ($(t).hasClass('anchor')) event.preventDefault();
                    }
                    if (scrolling) return false;

                    var jumplinkHeight;
                    var hash;
                    var hashOffset;
                    if (window.location.hash.length > 0 && t === 0) {//activating the jumplink from an external anchor link
                        hash = window.location.hash;
                        if ($(hash).length > 0) {
                            if ($(window).width() <= 991) {//mobileview
                                jumplinkHeight = stickyNavMobileContainer.height();
                                hashOffset = $(hash).offset().top + 400 + jumplinkHeight;
                            } else { //desktopview
                                jumplinkHeight = stickyNavDesktopContainer.height();
                                hash = window.location.hash;
                                hashOffset = $(hash).offset().top + 200 + jumplinkHeight;
                            }
                        }
                    } else {//standard jumplink click activation
                        hash = t.hash;
                        if ($(hash).length > 0) {
                            if ($(window).width() <= 991) {//mobileview
                                jumplinkHeight = stickyNavMobileContainer.height();
                                hashOffset = $(hash).offset().top - jumplinkHeight;
                            } else {//desktopview
                                jumplinkHeight = stickyNavDesktopContainer.height();
                                hash = t.hash;
                                hashOffset = $(hash).offset().top - jumplinkHeight;
                            }
                        }
                    }
                    if (hash !== '' && $(hash).length !== 0) {
                        $('html, body').animate({
                            scrollTop: hashOffset
                        }, 800, function () {
                            if (anchorElementWrappers !== null) { //using the wrappers
                                anchorElementWrappers.removeClass('active');
                                $(hash).parent(anchorElementWrappers).addClass('active');
                            }
                            else {//no wrappers
                                jumplinkContainer.find(jumplinkClass).removeClass('active');
                                $(hash).addClass('active');
                            }
                        });
                    }
                    if ($('.fancybox-container').hasClass('fancybox-is-open')) {
                        $.fancybox.close();
                    }
                }
            }//end smoothscroll

            function checkScrollLocation() {
                if (usingAnchors) {
                    for (var i = 0; i < anchorElements.length; i++) {
                        if (jumplinkTopDistance[i] <= window.pageYOffset && window.pageYOffset <= jumplinkTopDistance[i + 1]) {
                            if (anchorElementWrappers !== null) { //using the wrappers
                                anchorElementWrappers.removeClass('active');
                                anchorElementWrappers[i].className += " active";
                            }
                            else {//no wrappers
                                jumplinkContainer.find(jumplinkClass).removeClass('active');
                                anchorElements[i].className += " active";
                            }
                        }
                    }
                    if (window.pageYOffset < jumplinkTopDistance[0]) jumplinkContainer.find(jumplinkClass).removeClass('active');
                }
            }
        }
    }


});